import Vue from 'vue'
import Vuex from 'vuex'
import config from '../../../../config'

import { Device } from '@/services/device'

Vue.use(Vuex)

const state = {
  deviceIndex: 0,
  allDevices: [],
  device: null,
  vitals: [],
  submittedFeedbacks: [],
  unSubmittedFeedbacks: [],
  brushCoords: [],
  brushCoordIndex: 0,
  customDateRange: {},
  customDateSet: false,
  vitalsLength: false,
  selectedTabIndex: 0
}

const modules = {}

const getters = {
  device: state => state.device,
  allDevices: state => state.allDevices,
  deviceIndex: state => state.deviceIndex,
  vitals: state => state.vitals,
  submittedFeedbacks: state => state.submittedFeedbacks,
  unSubmittedFeedbacks: state => state.unSubmittedFeedbacks,
  brushCoords: state => state.brushCoords,
  brushCoordIndex: state => state.brushCoordIndex,
  currentDeviceId: state => state.allDevices?.[state.deviceIndex]?.id,
  customDateRange: state => state.customDateRange,
  customDateSet: state => state.customDateSet,
  vitalsLength: state => state.vitalsLength,
  selectedTabIndex: state => state.selectedTabIndex
}

const mutations = {
  setSingleProperty: (state, [prop, value]) => {
    state[prop] = value
  }
}

const actions = {
  setSingleProperty({ commit }, [key, value]) {
    commit('setSingleProperty', [key, value])
  },
  setBrushCoords({ commit }, brushCoords) {
    commit('setSingleProperty', ['brushCoords', brushCoords])
  },
  setBrushCoordIndex({ commit }, brushCoordIndex) {
    commit('setSingleProperty', ['brushCoordIndex', brushCoordIndex])
  },
  setdeviceIndex({ commit }, deviceIndex) {
    commit('setSingleProperty', ['deviceIndex', deviceIndex])
  },
  async fetchDeviceByIndex({ dispatch, state }, deviceIndex) {
    await dispatch('fetchDeviceDetails', { id: state.allDevices?.[deviceIndex]?.id })
  },
  async fetchallDevices({ dispatch, commit }) {
    const allDevices = await Device.getAllDevices()
    commit('setSingleProperty', ['allDevices', allDevices])
    if (allDevices?.length) {
      await dispatch('fetchDeviceDetails', { id: allDevices[0]?.deviceId })
    }
  },
  async fetchDeviceDetails({ commit, state, dispatch }, { id, startDate, endDate }) {
    if (!id || (!id && state.deviceIndex <= 0)) {
      id = state.allDevices[0]?.deviceId
    }
    commit('setSingleProperty', ['device', null])
    commit('setSingleProperty', ['vitals', []])
    commit('setSingleProperty', ['brushCoordIndex', 0])

    let deviceDetails
    let url
    if (startDate && endDate) {
      url = `${config.API_URL}/api/patientDetails/vitals?patientId=${id}&startDate=${startDate / 1000}&endDate=${endDate / 1000}`
      deviceDetails = await Device.getCompleteDeviceDetails(id, startDate, endDate)
    } else {
      // url = `${config.API_URL}/api/patientDetails/vitals?patientId=${id}`
      url = `https://assetanalysis.techolution.com/api/patientDetails/vitals?patientId=${id}`
      deviceDetails = await Device.getCompleteDeviceDetails(id)
    }
    commit('setSingleProperty', ['submittedFeedbacks', deviceDetails.submittedFeedback])
    commit('setSingleProperty', ['device', deviceDetails.device])
    commit('setSingleProperty', ['vitalsLength', deviceDetails.vitalLength])
    commit('setSingleProperty', ['unSubmittedFeedbacks', deviceDetails.unSubmittedFeedback])

    // reactive API integration
    const vitals = []
    const eventSource = new EventSource(url)
    eventSource.onmessage = (event) => {
      const json = JSON.parse(event.data)
      vitals.push(json)
      commit('setSingleProperty', ['vitals', vitals])
      dispatch('setLoader', false, { root: true })
    }
    eventSource.onerror = (error) => {
      // readyState === 0 (closed) means the remote source closed the connection,
      if (eventSource.readyState === 0) {
        eventSource.close()
      } else {
        console.log(error)
      }
    }
  },
  getMinMaxDate({ commit }) {
    state.vitals.sort((a, b) => a['datetime'] - b['datetime'])
    let customDateRange
    if (!state.customDateSet && state.vitalsLength) {
      customDateRange = {
        minDate: state.vitals[0].datetime,
        maxDate: state.vitals[state.vitals.length - 1].datetime
      }
      commit('setSingleProperty', ['customDateRange', customDateRange])
    } else {
      customDateRange = state.customDateRange
    }
    return customDateRange
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
  modules
}
